/* Ask Elaine — quiz engine. Reads AE_DATA (data.js). */
(function () {
  var root = document.getElementById('ask-elaine');
  if (!root) return;
  var D = AE_DATA;
  var cfg = {
    mode: root.getAttribute('data-mode') || 'shop',          // 'shop' on the live site, 'preview' for review
    contact: root.getAttribute('data-contact') || 'mailto:elaine@thedogherbalist.co.uk',
    shopUrl: root.getAttribute('data-shop-url') || ''
  };

  var state = { step: -1, a: {} };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function dogName() { return state.a.name ? state.a.name : 'your dog'; }
  function fill(t) { return esc(t).replace(/\{name\}/g, '<span class="ae-dog">' + esc(dogName()) + '</span>'); }
  function fillPlain(t) { return String(t).replace(/\{name\}/g, dogName()); }
  function money(n) { return '£' + Number(n).toFixed(2); }

  /* The question path depends on the answers so far: a details question for the chosen
     focus, and a follow-up only when that detail needs narrowing down. */
  function detailOpt() {
    var d = D.DETAILS[state.a.focus]; if (!d) return null;
    return d.options.filter(function (o) { return o.value === state.a.detail; })[0] || null;
  }
  function questionList() {
    var qs = [D.Q.name, D.Q.age, D.Q.size, D.Q.focus];
    var d = D.DETAILS[state.a.focus];
    qs.push(d ? { id: 'detail', step: 'Details', kicker: 'Tell us a little more', type: 'choice', title: d.title, options: d.options }
              : { id: 'detail', step: 'Details', kicker: 'Tell us a little more', type: 'choice', title: 'Which sounds most like {name}?', options: [] });
    var o = detailOpt();
    if (o && o.follow) qs.push({ id: 'detail2', step: 'More', kicker: o.follow.kicker, type: 'choice', title: o.follow.title, options: o.follow.options });
    qs.push(D.Q.health);
    return qs;
  }
  function allowed(o) {
    if (o.ages && o.ages.indexOf(state.a.age) < 0) return false;
    if (o.hideFor) for (var k in o.hideFor) if (o.hideFor[k].indexOf(state.a[k]) >= 0) return false;
    return true;
  }
  function optionsFor(q) { return (q.options || []).filter(allowed); }
  function planKey() {
    var o = detailOpt(); if (!o) return null;
    if (o.follow) return o.follow.options.some(function (x) { return x.value === state.a.detail2; }) ? state.a.detail2 : null;
    return o.value;
  }

  /* ---------- rendering ---------- */
  function render() {
    root.removeAttribute('data-busy');
    if (state.step < 0) return renderIntro();
    var qs = questionList();
    if (state.step >= qs.length) return renderPlan();
    renderQuestion(qs[state.step], state.step, qs.length);
  }

  function anim(el) { if (el) { el.classList.remove('ae-in'); void el.offsetWidth; el.classList.add('ae-in'); } }
  function focusTitle() { var h = root.querySelector('.ae-title'); if (h) { h.setAttribute('tabindex', '-1'); try { h.focus({ preventScroll: true }); } catch (e) {} } }
  function keepInView() { var r = root.getBoundingClientRect(); if (r.top < 0 || r.top > window.innerHeight * 0.4) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }

  function renderIntro() {
    root.innerHTML =
      '<div class="ae-stage ae-intro">' +
        '<span class="ae-script">Ask Elaine</span>' +
        '<h2 class="ae-title">Find your dog’s natural plan</h2>' +
        '<p class="ae-subtitle">Answer six quick questions and Elaine, our herbalist of 40+ years, will put together a plan for your dog: what to give, how much, and what to expect in the first month.</p>' +
        '<button type="button" class="ae-cta" data-act="start">Start the quiz <span aria-hidden="true">→</span></button>' +
        '<ul class="ae-trust"><li><span aria-hidden="true">🌿</span> Herbalist of 40+ years</li><li><span aria-hidden="true">🐾</span> 100% natural</li><li><span aria-hidden="true">⏱️</span> Takes about a minute</li></ul>' +
      '</div>';
    anim(root.firstChild);
  }

  function stepsBar(i) {
    var qs = questionList(), html = '<ol class="ae-steps" style="--n:' + qs.length + '" aria-label="Quiz progress">';
    qs.forEach(function (q, k) {
      var cls = k < i ? 'is-done' : (k === i ? 'is-now' : '');
      html += '<li class="' + cls + '"' + (k === i ? ' aria-current="step"' : '') + '><span class="ae-dot">' + (k < i ? '✓' : (k + 1)) + '</span><span class="ae-step-l">' + esc(q.step) + '</span></li>';
    });
    return html + '</ol>';
  }

  function renderQuestion(q, i, total) {
    var opts = q.type === 'text' ? [] : optionsFor(q);
    var html = '<div class="ae-stage">' + stepsBar(i) +
      '<span class="ae-script">' + esc(q.kicker) + '</span>' +
      '<h2 class="ae-title" id="ae-q">' + fill(q.title) + '</h2>' +
      (q.help ? '<p class="ae-subtitle">' + esc(q.help) + '</p>' : '');

    if (q.type === 'text') {
      html += '<form class="ae-textform" novalidate data-q="' + q.id + '">' +
        '<div class="ae-pillfield"><label class="ae-sr" for="ae-name">Your dog’s name</label>' +
        '<input id="ae-name" class="ae-pillinput" type="text" maxlength="30" autocomplete="off" required aria-required="true" placeholder="' + esc(q.placeholder) + '" value="' + esc(state.a[q.id] || '') + '">' +
        '<button type="submit" class="ae-pillbtn">Next <span aria-hidden="true">→</span></button></div></form>';
    } else {
      var tiles = q.layout === 'tiles';
      html += '<div class="ae-options' + (tiles ? ' ae-tiles ae-cols-' + opts.length : '') + '" role="group" aria-labelledby="ae-q">';
      opts.forEach(function (o, k) {
        var on = state.a[q.id] === o.value;
        html += '<button type="button" class="ae-opt' + (on ? ' is-on' : '') + '" style="--d:' + (k * 50) + 'ms" data-q="' + q.id + '" data-v="' + o.value + '" aria-pressed="' + on + '">' +
          (o.icon ? '<span class="ae-opt-icon' + (o.iconSize ? ' ae-ic-' + o.iconSize : '') + '" aria-hidden="true">' + o.icon + '</span>' : '') +
          '<span class="ae-opt-text"><span class="ae-opt-label">' + esc(o.label) + '</span>' +
          (o.sub ? '<span class="ae-opt-sub">' + esc(o.sub) + '</span>' : '') + '</span>' +
          (tiles ? '' : '<span class="ae-opt-arrow" aria-hidden="true">→</span>') + '</button>';
      });
      html += '</div>';
    }
    html += '<div class="ae-nav">' + (i > 0 ? '<button type="button" class="ae-link" data-act="back">← Back</button>' : '') + '</div></div>';
    root.innerHTML = html;
    anim(root.firstChild);
    keepInView();
    var inp = root.querySelector('.ae-pillinput');
    if (inp) inp.focus({ preventScroll: true }); else focusTitle();
  }

  function renderLoading(done) {
    root.innerHTML = '<div class="ae-stage ae-loading" role="status">' +
      '<span class="ae-leaf" aria-hidden="true">🌿</span>' +
      '<span class="ae-script">One moment</span>' +
      '<h2 class="ae-title">Elaine is putting together ' + esc(dogName() === 'your dog' ? 'your dog’s' : dogName() + '’s') + ' plan</h2>' +
      '<p class="ae-subtitle">Matching the right blends to ' + esc(dogName()) + '’s age, size and needs…</p></div>';
    anim(root.firstChild);
    var fast = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(done, fast ? 300 : 1600);
  }

  function planFor() {
    var key = planKey(), plan = key && D.PLANS[key];
    if (!plan) return null;
    var list = Array.isArray(plan.products) ? plan.products : (plan.products[state.a.age] || plan.products.adult);
    var bundle = plan.bundle ? (typeof plan.bundle === 'string' ? plan.bundle : plan.bundle[state.a.age]) : null;
    return { key: key, plan: plan, handles: list, bundle: bundle || null };
  }

  function howText(p) {
    if (p.how.kind === 'topical') return '<p>' + esc(p.how.text) + '</p>';
    if (p.how.kind === 'drops') return '<p>' + esc(p.how.schedule) + '</p><p class="ae-small">' + esc(D.DROPS_HOW) + '</p>';
    var size = state.a.size || 'medium';
    var amt = p.how.amounts[size];
    var puppy = state.a.age === 'puppy' && p.puppyHalf;
    return '<p><strong>' + esc(amt) + '</strong> for a ' + esc(size) + ' dog' + (puppy ? ' (puppies have half of this)' : '') + '. ' + esc(p.how.extra) + '</p>';
  }

  function renderPlan() {
    var r = planFor();
    if (!r) { state.step = 3; delete state.a.detail; delete state.a.detail2; return render(); }
    var products = r.handles.map(function (h) { var p = D.PRODUCTS[h]; p.handle = h; return p; });
    var flagged = state.a.health === 'vet' || state.a.health === 'preg';
    var needsCheck = flagged || (state.a.age === 'puppy' && products.some(function (p) { return !p.puppyOk; }));
    var note = (state.a.age === 'puppy' && r.plan.puppyNote) ? r.plan.puppyNote : r.plan.note;
    setupPricing(products, r.bundle);

    var ageWord = { puppy: 'puppy', adult: 'adult dog', senior: 'golden oldie' }[state.a.age] || 'dog';
    var html = '<div class="ae-stage ae-plan-stage">' +
        '<span class="ae-script">' + esc(dogName() === 'your dog' ? 'Your dog’s plan' : dogName() + '’s plan') + '</span>' +
        '<h2 class="ae-title">' + esc(r.plan.name) + '</h2>' +
        '<p class="ae-subtitle">Put together by Elaine for a ' + esc(state.a.size || '') + ' ' + esc(ageWord) + '.</p>' +
      '</div>' +
      '<div class="ae-plan">' +
      '<div class="ae-letter"><p>' + fill(note) + '</p><p class="ae-sign">With natural love and care,<br>Elaine 🌿</p></div>';

    if (r.plan.vet && !(state.a.age === 'puppy' && r.plan.puppyNote)) {
      html += '<div class="ae-vetnote" role="note"><strong>A note from Elaine:</strong> ' + fill(r.plan.vet) + '</div>';
    }
    if (needsCheck) {
      html += '<div class="ae-callout" role="note"><strong>Please check with Elaine before starting.</strong> ' +
        (state.a.health === 'vet' ? 'As ' + esc(dogName()) + ' is on medication or seeing the vet, Elaine would like to make sure this plan is right first.'
          : state.a.health === 'preg' ? 'As ' + esc(dogName()) + ' is pregnant or nursing, Elaine would like to make sure this plan is right first.'
          : 'Elaine likes to check which blends suit puppies before they start.') +
        ' <a href="' + esc(cfg.contact) + '">Send Elaine a message</a>, and she’ll get back to you personally.</div>';
    }

    html += '<h3 class="ae-sub">What’s in the plan</h3><div class="ae-products">';
    products.forEach(function (p) {
      html += '<article class="ae-prod" data-handle="' + p.handle + '">' +
        '<a class="ae-prod-img" href="' + cfg.shopUrl + '/products/' + p.handle + '" target="_blank" rel="noopener">' + imgTag(p.image, p.title) + '</a>' +
        '<div class="ae-prod-body">' +
          '<span class="ae-pill">' + esc(p.role) + '</span>' +
          '<h4 class="ae-prod-title"><a href="' + cfg.shopUrl + '/products/' + p.handle + '" target="_blank" rel="noopener">' + esc(p.title) + '</a></h4>' +
          '<p class="ae-price" data-price></p>' +
          '<div class="ae-how"><p class="ae-how-label">How to give it</p>' + howText(p) + '</div>' +
        '</div></article>';
    });
    html += '</div>';

    if (r.plan.timeline !== false) {
      html += '<h3 class="ae-sub">Your first 30 days</h3><ol class="ae-timeline">';
      D.TIMELINE.forEach(function (t) { html += '<li><span class="ae-when">' + esc(t.when) + '</span><span>' + fill(t.text) + '</span></li>'; });
      html += '</ol>';
    }

    html += '<h3 class="ae-sub" id="ae-order-h">How would you like to order?</h3>' +
      (needsCheck ? '<p class="ae-help">Once Elaine has said this plan is right for ' + esc(dogName()) + ', you can come back here to order.</p>' : '') +
      '<div class="ae-order" data-order' + (needsCheck ? ' data-locked' : '') + '></div>' +
      '<p class="ae-status" role="status" aria-live="polite"></p>';

    html += '<form class="ae-email" novalidate>' +
      '<h3 class="ae-sub">Email me ' + esc(dogName() === 'your dog' ? 'this' : dogName() + '’s') + ' plan</h3>' +
      '<p class="ae-help">Elaine will email you a copy of this plan, then check in a few weeks later to see how ' + esc(dogName()) + ' is getting on.</p>' +
      '<div class="ae-email-fields">' +
        '<label class="ae-sr" for="ae-fname">Your first name</label>' +
        '<input id="ae-fname" class="ae-input ae-field" type="text" autocomplete="given-name" maxlength="40" placeholder="Your first name" required>' +
        '<label class="ae-sr" for="ae-email">Email address</label>' +
        '<input id="ae-email" class="ae-input ae-field" type="email" autocomplete="email" placeholder="Email address" required>' +
      '</div>' +
      '<button type="submit" class="ae-btn ae-btn-secondary ae-btn-wide">Send my plan &amp; sign up</button>' +
      '<p class="ae-consent">By sending your plan, you’re also <strong>joining The Dog Herbalist mailing list</strong> for Elaine’s natural care tips, news and offers. You can unsubscribe at any time, and we never share your email.</p>' +
      '<p class="ae-email-msg" role="status" aria-live="polite"></p>' +
    '</form>';

    html += '<div class="ae-footer"><button type="button" class="ae-link" data-act="restart">Start again</button>' +
      '<button type="button" class="ae-link" data-act="copy">Copy a link to this plan</button></div>' +
      '<p class="ae-disclaimer">These are natural supplements to support everyday wellbeing. They aren’t a replacement for veterinary care. If you’re worried about your dog’s health, please see your vet.</p>' +
      '</div>';

    root.innerHTML = html;
    anim(root.querySelector('.ae-plan-stage')); anim(root.querySelector('.ae-plan'));
    renderPrices();
    saveHash();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    focusTitle();
    if (cfg.mode === 'shop') hydrate();
  }

  function imgTag(src, alt) {
    var kind = /Drops/.test(alt) ? 'Drops' : (/Bundle/.test(alt) ? 'Bundle' : 'Herbal powder');
    return '<img src="' + esc(src) + '&width=400" alt="' + esc(alt) + '" loading="lazy" width="200" height="200" data-kind="' + kind + '">';
  }
  function fixImages() {
    Array.prototype.forEach.call(root.querySelectorAll('img[data-kind]'), function (img) {
      if (img._ae) return; img._ae = 1;
      var swap = function () { var ph = document.createElement('span'); ph.className = 'ae-noimg'; ph.textContent = img.getAttribute('data-kind'); img.replaceWith(ph); };
      if (img.complete && img.naturalWidth === 0 && img.src) swap(); else img.addEventListener('error', swap);
    });
  }

  /* ---------- pricing: Subscribe & Save, bundle, one-off ---------- */
  var pricing = null;
  function pct(pence, off) { return Math.round(pence * (100 - off) / 100); }
  function defaultWeeks() { return { small: 8, medium: 6, large: 4 }[state.a.size] || 4; }
  function setupPricing(products, bundleHandle) {
    pricing = {
      subs: D.SUBS.map(function (x) { return { weeks: x.weeks, pct: x.pct, label: x.label, minCycles: x.minCycles }; }),
      items: products.map(function (p) {
        var pence = Math.round(p.price * 100), sub = {};
        D.SUBS.forEach(function (x) { sub[x.weeks] = { id: null, pence: pct(pence, x.pct) }; });
        return { handle: p.handle, title: p.title, variant: null, pence: pence, available: true, sub: sub };
      }),
      bundle: bundleHandle && D.BUNDLES[bundleHandle] ? (function (b) {
        return { handle: bundleHandle, title: b.title, image: b.image, variant: null, pence: Math.round(b.price * 100), was: Math.round(b.was * 100), available: true };
      })(D.BUNDLES[bundleHandle]) : null,
      weeks: state.weeks || defaultWeeks(),
      canSubscribe: true
    };
  }
  function subTotal(weeks) { return pricing.items.reduce(function (s, it) { return s + (it.sub[weeks] ? it.sub[weeks].pence : it.pence); }, 0); }
  function fullTotal() { return pricing.items.reduce(function (s, it) { return s + it.pence; }, 0); }
  function m(p) { return money(p / 100); }

  function renderPrices() {
    var w = pricing.weeks;
    pricing.items.forEach(function (it) {
      var el = root.querySelector('[data-handle="' + it.handle + '"] [data-price]');
      if (!el) return;
      var sub = it.sub[w];
      el.innerHTML = m(it.pence) + (pricing.canSubscribe && sub ? ' <span class="ae-sub-note">or <strong>' + m(sub.pence) + '</strong> with Subscribe &amp; Save</span>' : '') +
        (it.available ? '' : ' <span class="ae-oos">Out of stock</span>');
    });
    renderOrder();
    fixImages();
  }

  function renderOrder() {
    var box = root.querySelector('[data-order]'); if (!box) return;
    var locked = box.hasAttribute('data-locked');
    var dis = locked ? ' disabled' : '';
    var full = fullTotal(), w = pricing.weeks, html = '';
    var planName = dogName() === 'your dog' ? 'this plan' : dogName() + '’s plan';
    var maxPct = Math.max.apply(null, pricing.subs.map(function (x) { return x.pct; }));

    if (pricing.canSubscribe) {
      var s = subTotal(w), sel = pricing.subs.filter(function (x) { return x.weeks === w; })[0];
      html += '<section class="ae-ocard ae-ocard-sub" aria-labelledby="ae-sub-h">' +
        '<span class="ae-flag">Best value</span>' +
        '<h4 class="ae-ocard-h" id="ae-sub-h">Subscribe &amp; Save up to ' + maxPct + '%</h4>' +
        '<p class="ae-ocard-lead">Delivered to your door on repeat, so ' + esc(dogName()) + ' never runs out. The more often it comes, the more you save.</p>' +
        '<div class="ae-freq" role="radiogroup" aria-label="Delivery frequency">';
      pricing.subs.forEach(function (x) {
        var on = x.weeks === w;
        html += '<button type="button" role="radio" aria-checked="' + on + '" class="ae-fopt' + (on ? ' is-on' : '') + '" data-weeks="' + x.weeks + '"' + dis + '>' +
          '<span class="ae-fopt-l">' + esc(x.label) + '</span><span class="ae-fopt-p">Save ' + x.pct + '%</span>' +
          '<span class="ae-fopt-t">' + m(subTotal(x.weeks)) + '</span></button>';
      });
      html += '</div>' +
        '<p class="ae-tip">Tip: a bag lasts a ' + esc(state.a.size || 'medium') + ' dog about ' + ({ small: '8', medium: '6', large: '4' }[state.a.size] || '4–8') + ' weeks.</p>' +
        '<div class="ae-ocard-price"><span class="ae-was">' + m(full) + '</span> <span class="ae-now">' + m(s) + '</span> <span class="ae-per">per delivery</span></div>' +
        '<p class="ae-save">You save ' + m(full - s) + ' every delivery</p>' +
        '<button type="button" class="ae-btn ae-btn-primary ae-btn-wide" data-act="buy"' + dis + '>Subscribe to ' + esc(planName) + '</button>' +
        '<p class="ae-small">' + (sel && sel.minCycles ? 'Minimum ' + sel.minCycles + ' deliveries, then change or cancel any time.' : 'Change, pause or cancel any time.') + '</p>' +
      '</section>';
    }

    if (pricing.bundle) {
      var b = pricing.bundle;
      html += '<section class="ae-ocard ae-ocard-bundle" aria-labelledby="ae-bundle-h">' +
        '<a class="ae-bundle-img" href="' + cfg.shopUrl + '/products/' + b.handle + '" target="_blank" rel="noopener">' + imgTag(b.image, b.title) + '</a>' +
        '<div class="ae-bundle-body">' +
          '<h4 class="ae-ocard-h" id="ae-bundle-h">Prefer a one-off order? Save with the bundle</h4>' +
          '<p class="ae-ocard-lead">Both products in this plan come together as the <a href="' + cfg.shopUrl + '/products/' + b.handle + '" target="_blank" rel="noopener">' + esc(b.title) + '</a>.</p>' +
          '<div class="ae-ocard-price"><span class="ae-was">' + m(b.was) + '</span> <span class="ae-now">' + m(b.pence) + '</span></div>' +
          '<p class="ae-save">You save ' + m(b.was - b.pence) + '</p>' +
          '<button type="button" class="ae-btn ae-btn-secondary" data-act="buy-bundle"' + (dis || (b.available ? '' : ' disabled')) + '>' + (b.available ? 'Add bundle to basket' : 'Bundle out of stock') + '</button>' +
        '</div></section>';
    }

    html += '<p class="ae-once">' + (locked ? '' : '<button type="button" class="ae-link" data-act="buy-once">Or buy ' + (pricing.items.length > 1 ? 'the products' : 'it') + ' once for ' + m(full) + '</button>') + '</p>';
    box.innerHTML = html;
  }

  /* ---------- live shop data ---------- */
  function getJSON(h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }
  function weeksOf(name) { var mm = /(\d+)\s*week/i.exec(name || ''); return mm ? +mm[1] : null; }
  function hydrate() {
    var handles = pricing.items.map(function (it) { return it.handle; });
    if (pricing.bundle) handles.push(pricing.bundle.handle);
    Promise.all(handles.map(getJSON)).then(function (rows) {
      var allSub = true, liveSubs = {};
      pricing.items.forEach(function (it, i) {
        var d = rows[i];
        if (!d) { allSub = false; return; }
        var v = d.variants.filter(function (x) { return x.available; })[0] || d.variants[0];
        it.variant = v.id; it.pence = v.price; it.available = v.available;
        var plans = {};
        (d.selling_plan_groups || []).forEach(function (g) { (g.selling_plans || []).forEach(function (sp) {
          var wk = weeksOf(sp.name); if (!wk) return;
          var adj = (sp.price_adjustments || [])[0];
          plans[sp.id] = wk;
          if (adj && adj.value_type === 'percentage') liveSubs[wk] = adj.value;
        }); });
        it.sub = {};
        (v.selling_plan_allocations || []).forEach(function (al) { var wk = plans[al.selling_plan_id]; if (wk) it.sub[wk] = { id: al.selling_plan_id, pence: al.price }; });
        if (!Object.keys(it.sub).length) allSub = false;
      });
      pricing.subs = pricing.subs.filter(function (x) { return pricing.items.every(function (it) { return it.sub[x.weeks]; }); })
        .map(function (x) { if (liveSubs[x.weeks] != null) x.pct = liveSubs[x.weeks]; return x; });
      pricing.canSubscribe = allSub && pricing.subs.length > 0;
      if (pricing.canSubscribe && !pricing.subs.some(function (x) { return x.weeks === pricing.weeks; })) pricing.weeks = pricing.subs[0].weeks;
      if (pricing.bundle) {
        var bd = rows[rows.length - 1];
        if (!bd) pricing.bundle = null;
        else {
          var bv = bd.variants.filter(function (x) { return x.available; })[0] || bd.variants[0];
          var b = pricing.bundle; b.variant = bv.id; b.pence = bv.price; b.available = bv.available;
          b.was = bv.compare_at_price && bv.compare_at_price > bv.price ? bv.compare_at_price : fullTotal();
          if (b.was <= b.pence) pricing.bundle = null;
        }
      }
      renderPrices();
    });
  }

  function cartAdd(items) {
    var status = root.querySelector('.ae-status');
    status.textContent = 'Adding to your basket…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (res) { if (!res.ok) throw res; window.location.href = '/cart'; })
      .catch(function () { status.textContent = 'Sorry, that couldn’t be added. Please try again, or use the product links above.'; });
  }
  function addToBasket(how) {
    var status = root.querySelector('.ae-status');
    var r = planFor(), prop = { _quiz: 'Ask Elaine: ' + r.plan.name };
    if (cfg.mode !== 'shop') {
      status.textContent = how === 'sub' ? 'Preview only: on the website this adds the plan to the basket as a subscription, delivered every ' + pricing.weeks + ' weeks.'
        : how === 'bundle' ? 'Preview only: on the website this adds the bundle to the basket.' : 'Preview only: on the website this adds the products to the basket as a one-off order.';
      return;
    }
    if (how === 'bundle') { if (pricing.bundle && pricing.bundle.variant) cartAdd([{ id: pricing.bundle.variant, quantity: 1, properties: prop }]); return; }
    var items = pricing.items.filter(function (it) { return it.variant; }).map(function (it) {
      var o = { id: it.variant, quantity: 1, properties: prop };
      if (how === 'sub' && it.sub[pricing.weeks] && it.sub[pricing.weeks].id) o.selling_plan = it.sub[pricing.weeks].id;
      return o;
    });
    if (!items.length) { status.textContent = 'Sorry, something went wrong. Please try again, or use the product links above.'; return; }
    cartAdd(items);
  }

  function sendEmail(form) {
    var msg = form.querySelector('.ae-email-msg');
    var fname = form.querySelector('#ae-fname').value.trim();
    var email = form.querySelector('#ae-email').value.trim();
    if (!fname) { msg.textContent = 'Please add your first name.'; form.querySelector('#ae-fname').focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { msg.textContent = 'Please enter a valid email address.'; form.querySelector('#ae-email').focus(); return; }
    fname = fname.charAt(0).toUpperCase() + fname.slice(1);
    var r = planFor();
    var slug = String(state.a.name || 'dog').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 30) || 'dog';
    var tags = ['newsletter', 'ask-elaine', 'ask-elaine-' + state.a.focus, 'ask-elaine-plan-' + r.key, 'ask-elaine-' + state.a.age,
      'ask-elaine-size-' + state.a.size, 'ask-elaine-dog-' + slug, 'ask-elaine-to-send'];
    if (state.a.health === 'vet' || state.a.health === 'preg') tags.push('ask-elaine-check-first');
    if (cfg.mode !== 'shop') { msg.textContent = 'Preview only: on the website this would add ' + fname + ' to your customers and mailing list, tagged: ' + tags.join(', '); return; }
    var body = new URLSearchParams();
    body.append('form_type', 'customer'); body.append('utf8', '✓');
    body.append('contact[first_name]', fname);
    body.append('contact[email]', email);
    body.append('contact[tags]', tags.join(','));
    body.append('contact[accepts_marketing]', 'true');
    msg.textContent = 'Sending…';
    fetch('/contact#ae', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
      .then(function (res) {
        if (/challenge/.test(res.url)) { window.location.href = res.url; return; }
        form.innerHTML = '<h3 class="ae-sub">Thank you, ' + esc(fname) + '! 🌿</h3><p class="ae-help">Elaine will email ' + esc(dogName() === 'your dog' ? 'your' : dogName() + '’s') + ' plan to you within the hour. You’re on our mailing list now too, so look out for a welcome email from us.</p>';
      })
      .catch(function () { msg.textContent = 'Sorry, that didn’t go through. Please try again.'; });
  }

  /* ---------- shareable link: #plan=... restores a plan ---------- */
  function saveHash() {
    var p = new URLSearchParams();
    ['name', 'age', 'size', 'focus', 'detail', 'detail2', 'health'].forEach(function (k) { if (state.a[k]) p.set(k, state.a[k]); });
    try { history.replaceState(null, '', '#' + p.toString()); } catch (e) {}
  }
  function loadHash() {
    if (!location.hash || location.hash.length < 2) return false;
    var p = new URLSearchParams(location.hash.slice(1));
    ['name', 'age', 'size', 'focus', 'detail', 'detail2', 'health'].forEach(function (k) { if (p.get(k)) state.a[k] = p.get(k).slice(0, 30); });
    var pk = p.get('plan');
    if (pk && !state.a.detail) {
      Object.keys(D.DETAILS).forEach(function (f) {
        D.DETAILS[f].options.forEach(function (o) {
          if (state.a.detail) return;
          if (!o.follow && o.value === pk) { state.a.focus = f; state.a.detail = pk; }
          else if (o.follow && o.follow.options.some(function (x) { return x.value === pk; })) { state.a.focus = f; state.a.detail = o.value; state.a.detail2 = pk; }
        });
      });
    }
    if (!planKey()) { state.a = {}; return false; }
    state.step = questionList().length;
    return true;
  }

  /* ---------- events ---------- */
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || b.disabled) return;
    var act = b.getAttribute('data-act');
    if (b.classList.contains('ae-opt')) {
      if (root.hasAttribute('data-busy')) return;
      root.setAttribute('data-busy', '');
      var q = b.getAttribute('data-q');
      var v = b.getAttribute('data-v');
      if ((q === 'focus' || q === 'age') && state.a[q] !== v) { delete state.a.detail; delete state.a.detail2; }
      if (q === 'detail' && state.a.detail !== v) delete state.a.detail2;
      if (q === 'age' && state.a.age !== v && state.a.age && (v === 'puppy' || state.a.age === 'puppy')) delete state.a.health;
      state.a[q] = b.getAttribute('data-v');
      Array.prototype.forEach.call(root.querySelectorAll('.ae-opt'), function (x) { x.classList.toggle('is-on', x === b); });
      setTimeout(function () {
        state.step++;
        if (state.step >= questionList().length) renderLoading(render); else render();
      }, 180);
      return;
    }
    if (act === 'start') { state.step = 0; render(); }
    else if (act === 'back') { state.step--; render(); }
    else if (act === 'restart') { state = { step: 0, a: {} }; try { history.replaceState(null, '', location.pathname + location.search); } catch (err) {} render(); }
    else if (act === 'buy') addToBasket('sub');
    else if (act === 'buy-once') addToBasket('once');
    else if (act === 'buy-bundle') addToBasket('bundle');
    else if (b.hasAttribute('data-weeks')) { pricing.weeks = state.weeks = +b.getAttribute('data-weeks'); renderPrices(); var f = root.querySelector('[data-weeks="' + pricing.weeks + '"]'); if (f) f.focus(); }
    else if (act === 'copy') {
      var done = function () { b.textContent = 'Link copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(done, function () { b.textContent = location.href; });
      else b.textContent = location.href;
    }
  });
  root.addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target;
    if (f.classList.contains('ae-textform')) {
      var v = f.querySelector('input').value.trim();
      if (!v) {
        if (!f.querySelector('.ae-field-msg')) { var msg = document.createElement('p'); msg.className = 'ae-field-msg'; msg.setAttribute('role', 'alert'); msg.textContent = 'Please tell us your dog’s name so we can write the plan for them.'; f.appendChild(msg); }
        f.querySelector('input').focus(); return;
      }
      state.a.name = v.charAt(0).toUpperCase() + v.slice(1);
      state.step++; render();
    } else if (f.classList.contains('ae-email')) sendEmail(f);
  });

  loadHash();
  render();
})();
